module.exports = __webpack_public_path__ + "img/kanban.675e88dd.jpg";